import React from 'react'

import { FormattedMessage, useIntl } from 'react-intl'
import { useSelector } from 'react-redux'
import { useRouteMatch } from 'react-router-dom'

import { AnalyticsPostCampaignReportGlossaryEntry } from '@components/Analytics/PostCampaignReport/Glossary'
import { CPM_EXPLAINED } from '@constants'
import { PCRChannels } from '@enums'
import { IApplicationState } from '@store'
import { selectCampaignOperatingRegionTaxName } from '@store/campaigns'
import { selectStoriesTotalSpend } from '@store/postCampaignReport'
import { selectCampaignId } from '@store/router'
import Theme from '@theme'
import { Link } from '@tribegroup'

const AnalyticsPostCampaignReportGlossaryStory: React.FC = () => {
  const match = useRouteMatch()
  const intl = useIntl()
  const campaignId = selectCampaignId(match)!

  const currency = useSelector(
    (state: IApplicationState) =>
      selectStoriesTotalSpend(state, campaignId, PCRChannels.IGStories).currency,
  )
  const taxName = useSelector((state: IApplicationState) =>
    selectCampaignOperatingRegionTaxName(state, campaignId, intl, currency),
  )

  return (
    <React.Fragment>
      <AnalyticsPostCampaignReportGlossaryEntry translationKey="story.published" />
      <AnalyticsPostCampaignReportGlossaryEntry
        translationKey="story.spend"
        values={{
          taxDisplay: taxName,
        }}
      />
      <AnalyticsPostCampaignReportGlossaryEntry translationKey="story.followers" />

      <AnalyticsPostCampaignReportGlossaryEntry translationKey="story.reach" />
      <AnalyticsPostCampaignReportGlossaryEntry translationKey="story.reachPercentage" />
      <AnalyticsPostCampaignReportGlossaryEntry translationKey="story.impressions" />
      <AnalyticsPostCampaignReportGlossaryEntry
        translationKey="story.cpm"
        values={{
          link: (
            <Link href={CPM_EXPLAINED} target="_blank" color={Theme.primaryColor} lowercase>
              <FormattedMessage id="core.text.clickHere" />
            </Link>
          ),
        }}
      />
    </React.Fragment>
  )
}

export default AnalyticsPostCampaignReportGlossaryStory
